export interface FoodItemModel {
  id?: string | null
  peso?: number | null
  stock?: number | null
  estado?: string | null
  categoria?: string | null
  proporcion?: number | null
  stockTeorico?: number | null
  codigoInsumo?: string | null
  nombreInsumo?: string | null
  unidadMedida?: UnidadMedida | null
  historialCostos?: HistorialCosto[] | null
  precioReferencial?: number | null
}

interface HistorialCosto {
  costo?: number | null
  cantidad?: number | null
  idIngreso?: string | null
  fechaFactura?: string | null
}

export enum UnidadMedida {
  Kg = 'KG',
  Lt = 'LT',
  Ml = 'ML',
  Un = 'UN'
}
